import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock, Sparkles } from 'lucide-react';
const CHECKOUT_URL = 'https://meal-preap.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 bg-slate-950 relative" id="seccion-compra" data-id="element-148" data-mp="qk6gmrpg7epe">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-100/60 via-slate-950 to-slate-950 pointer-events-none" data-id="element-149" data-mp="uk8ib0v6o84o"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-150" data-mp="1f2aavbyh34io">
        <div className="text-center mb-5" data-id="element-151" data-mp="1f0pgpng2lnlc">
          <div className="inline-flex items-center gap-2.5 bg-brand-100 text-brand-700 border border-brand-200 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_6px_20px_rgba(30,51,38,0.15)]" data-id="element-152" data-mp="1a37ios3lcss4">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-153" data-mp="22seehjbnv49o" />
            <span data-id="element-154" data-mp="22txtl6lkz99v">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            <span className="tabular-nums text-ink text-base sm:text-lg font-black tracking-wide" data-id="element-155" data-mp="1xtte9jweskl8">
              {String(timeLeft.h).padStart(2, '0')}:
              {String(timeLeft.m).padStart(2, '0')}:
              {String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-lav-600 font-medium text-sm flex items-center justify-center gap-2" data-id="element-156" data-mp="2limgfy3mjooa">
            ⚠️ Después sube $5.000 ARS. No vuelve.
          </p>
          <div className="w-full max-w-md mx-auto mt-3 bg-lav-100 rounded-full h-1.5 overflow-hidden" data-id="element-157" data-mp="eu3vadz14zh8">
            <div className="bg-brand-500 h-full w-[72%]" data-id="element-158" data-mp="jt6zxxb3l3oo"></div>
          </div>
          <p className="text-[11px] text-slate-500 mt-1.5" data-id="element-159" data-mp="jv9o0bsowmqr">
            Precio de lanzamiento por tiempo limitado
          </p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-ink mb-5" data-id="element-160" data-mp="a2ub3sw92ocq">
          EMPEZÁ TU MEAL PREP HOY
        </h2>

        {/* Plan selector */}
        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí tu Meal Prep Fitness Listo" data-id="element-161" data-mp="3sbcysqf3mrjb">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border p-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-slate-950 border-brand-400 bg-white shadow-[0_8px_28px_rgba(30,51,38,0.14)]" data-id="element-162" data-mp="3ic44txk8hcwy">
            <div className="flex items-start gap-3" data-id="element-163" data-mp="361mpji9lwazh">
              {/* Radio */}
              <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-164" data-mp="3120ad3a7wko1">
                <span className="w-2 h-2 rounded-full bg-white" data-id="element-165" data-mp="3aywaolpyq0hi"></span>
              </span>

              {/* Left content */}
              <div className="min-w-0 flex-1" data-id="element-166" data-mp="3ot5q7ig5rcyc">
                <h3 className="font-bold text-ink text-base flex items-center gap-2 leading-tight" data-id="element-167" data-mp="3jsrglvywruy7">
                  <span className="shrink-0" data-id="element-168" data-mp="2k4gx8m0ezy0">
                    <Sparkles className="w-6 h-6 text-brand-500" data-id="element-169" data-mp="2hs2h5fgn7pp" />
                  </span>
                  <span className="truncate" data-id="element-170" data-mp="3tqxgk815mr0f">
                    PUNTO DIGITAL™ — MEAL PREP FITNESS LISTO
                  </span>
                </h3>
                <p className="text-brand-600 text-xs font-medium mt-0.5" data-id="element-171" data-mp="1zco4tv9heyp5">
                  6 Tomos + 5 Bonos
                </p>
                <p className="text-slate-400 text-xs mt-1.5 leading-snug" data-id="element-172" data-mp="qeelmkazv1bj">
                  Ideal para personas que quieren organizar sus comidas, ahorrar
                  tiempo y mantener una alimentación fitness sin improvisar.
                </p>
                <p className="text-[11px] font-medium mt-1.5 text-brand-600" data-id="element-173" data-mp="14epcvog7uhx8">
                  Precio de lanzamiento
                </p>
              </div>

              {/* Right price column */}
              <div className="shrink-0 text-right pl-1" data-id="element-174" data-mp="cnjkju6qloii">
                <p className="text-slate-500 line-through text-xs leading-none mb-1" data-id="element-175" data-mp="cob7kgm9qdx6">
                  $49.000
                </p>
                <p className="text-2xl sm:text-3xl font-black text-ink leading-none" data-id="element-176" data-mp="lg3a8551wir7">
                  $19.990
                </p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-177" data-mp="3l4ebcba9fig8">ARS</p>
              </div>
            </div>
          </button>
        </div>

        {/* Single main CTA */}
        <div className="max-w-2xl mx-auto mt-5" data-id="element-178" data-mp="3hlp2zwpg77il">
          <Button className="w-full text-base py-4" onClick={() => {
          window.location.href = CHECKOUT_URL;
        }} data-id="element-179" data-mp="3hkdtrhd8h7k3">
            🥗 QUIERO MI MEAL PREP FITNESS
          </Button>
          <p className="text-center text-xs text-slate-500 mt-2" data-id="element-180" data-mp="38mtsw9ja9da0">
            Garantía 7 días · Pago seguro · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}